import { Product } from "@core/models/product.model";

export class GetProductAction {
  static readonly type = '[GetProduct]';
  constructor(public idProduct: string) {}
}

export class GetProductFailedAction {
  static readonly type = '[GetProduct] Failed';
  constructor(public message: string) {}
}

export class GetProductInitializedAction {
  static readonly type = '[GetProduct] Initialized';
  constructor() {}
}

export class GetProductSuccessAction {
  static readonly type = '[GetProduct] Success';
  constructor(public product: Product) {}
}